import { MenuItem } from "@blueprintjs/core"
import React from "react"
import CustomCheckbox from "components/Atoms/CustomCheckbox"
import CustomDateInput from "components/Atoms/CustomDateInput"
import CustomFormGroup from "components/Atoms/CustomFormGroup"
import StaticSelector from "components/Atoms/StaticSelector"
import StringInput from "components/Atoms/StringInput"
import DynamicSelector from "components/Molecules/DynamicSelector"
import { CROP_VARIETIES } from "graphql/plot.graphql"
import { USERS } from "graphql/selector.queries.gql"

const Crop = ({ id, isArchived, groups }) => {
  const path = `crops.${id}.`

  return (
    <div className="vt-crop">
      <div className="grid grid-cols-4 gap-4">
        <StringInput path={path + "name"} label="Name" required />
        <DynamicSelector
          label="Variety"
          path={path + "variety"}
          searchVector={["commodity.name", "name"]}
          labelElement="commodity.name"
          query={CROP_VARIETIES}
          disabled={isArchived}
          big={true}
          required
        />
        <CustomDateInput
          big={true}
          label="Sowing Date"
          path={path + "sowingDate"}
          disabled={isArchived}
          required
        />
        <CustomDateInput
          big={true}
          label="Harvesting Date"
          labelInfo={<span className="vt-label-muted">(Estimated)</span>}
          path={path + "harvestingDate"}
          disabled={isArchived}
        />
      </div>
      <div className="grid grid-cols-4 gap-4 mt-2">
        <StringInput
          label="Registration Code"
          path={path + "registrationCode"}
        />
        <StringInput
          label="Growing Cycle"
          type="number"
          path={path + "growingCycle"}
          disabled={isArchived}
        />
        <StringInput
          label="Number Of Saplings"
          path={path + "numberOfSaplings"}
          disabled={isArchived}
        />
        <DynamicSelector
          query={USERS}
          big={true}
          variables={{ group: "Agronomist" }}
          name="fullName"
          searchVector={["fullName"]}
          label="Agronomist"
          path={path + "agronomist"}
          disabled={isArchived}
        />
      </div>
      <div className="grid grid-cols-4 gap-4 mt-3">
        <StringInput
          label="Plot Codename"
          path={path + "referenceId"}
          disabled
        />
        <StringInput
          label="Estd. Harvest Quantity"
          path={path + "estimatedHarvestQuantity"}
        />
        <StaticSelector
          itemRenderer={(item, { handleClick, modifiers }) => {
            return (
              <MenuItem
                active={modifiers.active}
                key={item.id}
                onClick={handleClick}
                text={item?.name}
                labelElement={item?.codename}
              />
            )
          }}
          big={true}
          label="Alternate Group"
          path={path + "alternateCropGroupId"}
          items={groups}
        />
        <CustomFormGroup big={true} disabled={isArchived} label="Misc">
          <div className="flex">
            <CustomCheckbox
              disabled={isArchived}
              className="mr-3"
              path={path + "isFinishedGood"}
              label="Trading Good"
            />
            <CustomCheckbox
              disabled={isArchived}
              className="mr-3"
              path={path + "isRawMaterial"}
              label="Raw Material"
            />{" "}
          </div>
        </CustomFormGroup>
      </div>
    </div>
  )
}

export default Crop
